// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5522":"css/app.7037","7949":"css/admin-app.7037"}[chunkId] + ".css";
};